import { GrowthBook } from '@growthbook/growthbook-react';
import { EnvConfig } from '@model/config/env-config';
import { Logging } from '@util/logging';

const API_HOST = 'https://cdn.growthbook.io';
const CLIENT_KEY = EnvConfig.get().GROWTHBOOK_CLIENT_KEY || 'test';

export const growthbook = new GrowthBook({
  apiHost: API_HOST,
  clientKey: CLIENT_KEY,
  enableDevMode: true,
  subscribeToChanges: true,
  trackingCallback: (experiment, result) => {
    Logging.log({ text: `Viewed Experiment: ${JSON.stringify(experiment)}, ${JSON.stringify(result)}` });
    const dataLayer = (window as any).dataLayer;
    if (dataLayer) {
      dataLayer.push({ event: 'gb.experiment', gbExperimentId: experiment.name, gbVariationId: result.variationId });
    }
  }
});
growthbook.init({
  streaming: true
});
